<div class="vc-field">
   <label
      *ngIf="label"
      class="vc-label">
      {{ label() }}
      <span
         *ngIf="required()"
         class="required-asterisk">
         *
      </span>
   </label>
   <div [ngClass]="sizeClass()">
      <p-multiselect
         [appendTo]="appendTo()"
         [styleClass]="variantClass()"
         [inputId]="inputId()"
         [options]="options()"
         [optionLabel]="optionLabel()"
         [optionValue]="optionValue()"
         [placeholder]="placeholder()"
         [disabled]="disabled()"
         [required]="required()"
         [optionDisabled]="optionDisabled()"
         [showClear]="showClear()"
         [(ngModel)]="selectedItems"
         (onChange)="onSelectionChange($event)"
         #ngModelCtrl="ngModel"
         [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)"
         [display]="display()"
         [selectedItemsLabel]="selectedItemsLabel()"></p-multiselect>
   </div>
</div>
